

export class ExpenseOutputWithStatus implements IExpenseOutputWithStatus {
    /** The auto-generated id of the expense master */
    expense_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The company name with 255 character */
    company_name!: string;
    /** The vehicle number with 255 character */
    vehicle_number!: string;
    /** The expense name with 255 character */
    expense_type_name!: string;
    /** The maintenance type name with 255 character */
    maintenance_type_name!: string;
    /** The total amount of fuel */
    total_amount!: number;
    /** The current odometer of vehicle */
    current_odometer!: number;
    /** The  expense date and time */
    expense_date_time!: string;
    /** Manage status of expense. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IExpenseOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expense_id = _data["expense_id"];
            this.branch = _data["branch"];
            this.company_name = _data["company_name"];
            this.vehicle_number = _data["vehicle_number"];
            this.expense_type_name = _data["expense_type_name"];
            this.maintenance_type_name = _data["maintenance_type_name"];
            this.total_amount = _data["total_amount"];
            this.current_odometer = _data["current_odometer"];
            this.expense_date_time = _data["expense_date_time"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ExpenseOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expense_id"] = this.expense_id;
        data["branch"] = this.branch;
        data["company_name"] = this.company_name;
        data["vehicle_number"] = this.vehicle_number;
        data["expense_type_name"] = this.expense_type_name;
        data["maintenance_type_name"] = this.maintenance_type_name;
        data["total_amount"] = this.total_amount;
        data["current_odometer"] = this.current_odometer;
        data["expense_date_time"] = this.expense_date_time;
        data["status"] = this.status;
        return data; 
    }
}

export interface IExpenseOutputWithStatus {
    /** The auto-generated id of the expense master */
    expense_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The company name with 255 character */
    company_name: string;
    /** The vehicle number with 255 character */
    vehicle_number: string;
    /** The expense name with 255 character */
    expense_type_name: string;
    /** The maintenance type name with 255 character */
    maintenance_type_name: string;
    /** The total amount of fuel */
    total_amount: number;
    /** The current odometer of vehicle */
    current_odometer: number;
    /** The  expense date and time */
    expense_date_time: string;
    /** Manage status of expense. 0 For De-active, 1 For Active */
    status: number;
}

